const JW_VIDEO_UPDATED = (state, jwVideo) => {
  state.jwVideo = jwVideo
}

const PLAYING_VIDEO_ID_UPDATED = (state, videoId) => {
  state.playingVideoId = videoId
}

const PLAYING_VIDEO_TIME_UPDATED = (state, time) => {
  state.playingVideoTime = time
}

const IS_WATCHING_FULLSCREEN_UPDATED = (state, isWatchingFullscreen) => {
  state.isWatchingFullscreen = isWatchingFullscreen
}

const CURRENT_QUIZ_ID_UPDATED = (state, quizId) => {
  state.currentQuizId = quizId
}

export default {
  JW_VIDEO_UPDATED,
  PLAYING_VIDEO_ID_UPDATED,
  PLAYING_VIDEO_TIME_UPDATED,
  IS_WATCHING_FULLSCREEN_UPDATED,
  CURRENT_QUIZ_ID_UPDATED,
}
